import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'sistema/videos',
		component: Base,
		children: [
			{
				path: '',
				name: 'VideosList',
				component: List,
				meta: {
					path: '/sistema/videos',
					pai: 'Sistema',
					title: 'Admin - Vídeos',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Vídeos',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'VideosNovo',
				component: Form,
				meta: {
					path: '/sistema/videos',
					pai: 'Sistema',
					title: 'Admin - Vídeos - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Vídeos',
						class: '',
						active: false,
						url: '/sistema/videos'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'VideosEditar',
				component: Form,
				meta: {
					path: '/sistema/videos',
					pai: 'Sistema',
					title: 'Admin - Vídeos - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Vídeos',
						class: '',
						active: false,
						url: '/sistema/videos'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]